<template>
  <div>
    <div class="cate">
      <div class="cate_police">
        <div class="cate-all">问卷类别：</div>
        <div class="subject">
          <span
            v-for="(item, index) in questionnaireClass"
            :key="index"
            :class="{heightlight : questionindex==index}"
            @click="quesionArea(index,item)"
          >{{ item.name }}</span>
        </div>
      </div>

      <div class="cate_police">
        <div class="cate-all">全部警种：</div>
        <div ref="jzlistobjerthree" :class='["subject", jzlist&&putaway ? "hiddenlist" : ""]'>
          <span
            v-for="(item, index) in policeClassification"
            :key="index"
            :class="{heightlight : policeClassindex==index}"
            @click="policeClassArea(index,item)"
          >{{ item.name }}</span>
          <div v-if="jzlist&&putaway" class="showlist" @click="()=>{putaway = !putaway}">
            <span>更多</span>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <div v-if="jzlist&&!putaway" class="showlist" @click="()=>{putaway = !putaway}">
            <span>收起</span>
            <i class="el-icon-caret-top"></i>
          </div>
        </div>
      </div>

      <!-- <div class="cate_police">
        <div class="cate-all">地市/州 ：</div>
        <div class="subject">
          <span
            v-for="(item, index) in cityList"
            :key="index"
            :class="{heightlight : cityIndex==index}"
            @click="selectCity(index,item)"
          >{{ item.name }}</span>
        </div>
      </div>-->
      <div class="cate_police"
        style="border-top: 1px solid #dcdfe6;margin-left:86px;padding-top:24px;display:flex;align-items: center;"
      >
        <div class="subject" style="padding-right: 30px;"></div>
        <el-input
          @keyup.enter.native="questionMap"
          size="large"
          placeholder="请输入搜索内容"
          v-model="listQuerya.Name"
          class="input-with-select"
          style="width:287px;height:40px;font-size:16px;border-radius:4px;flex-shrink: 0;"
        >
          <el-button
            slot="append"
            @click="questionMap"
            icon="el-icon-search"
            style="background:#51565C;border-radius:0px;height:100%;color:white;font-size:16px;"
          ></el-button>
        </el-input>
      </div>
    </div>

    <div class="box">
      <div class="leftbox">
        <div style="max-height:900px;min-height:350px">
          <div class="leftboxmetter" v-if="tableData.length!==0">
            <div
              class="question"
              v-for="(item,index) in tableData "
              :key="index"
              @click="questionget(item)"
              style="cursor: pointer;"
            >
              <div>
                <div v-html="item.name"></div>
              </div>
              <div class="jz-and-dept">
                <div @click="questionget(item)" style="cursor: pointer;"></div>
                <div>创建单位：{{item.deptname}}</div>
              </div>
            </div>
          </div>
          <div v-else style="margin-top:20px">
            <nodata></nodata>
          </div>
        </div>
        <div class="page">
          <el-pagination
            v-if="dataCount>0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="dataCount"
            background
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- <linecom></linecom> -->
  </div>
</template>
<script>
import { getCity } from '@/api/public.js';
import * as vote from '@/api/vote/vote.js';
import linecom from '@/components/linecom/index';
import vHeader from '../header/index';

export default {
  components: {
    vHeader,
    linecom,
  },
  data() {
    return {
      cityList: [{ name: '全部', id: 0 }],
      cityIndex: 0,
      newList: [
        { subType: 0, name: '最新' },
        { subType: 1, name: '最热' },
      ],
      newIndex: 0,
      policeClassification: [{ name: '全部', id: 0 }], //全部警种
      policeClassindex: 0, //高亮默认为全部
      questionnaireClass: [{ name: '全部', id: 0 }],
      questionindex: 0,
      chooseClass: ['全部', '最新', '最热'], //选择类别
      chooseClassindex: 0, //高亮默认为全部
      tableData: [],
      currentPage: 1,
      pageSize: 16,
      dataCount: 0,
      value: 3.3,
      listQuery: {
        // 查询字典条件
        page: 1,
        limit: 30,
        key: null,
        namespaceId: null,
      },
      listQuerya: {
        // 查询教师数据库条件
        Page: 1,
        Limit: 16,
        key: null,
        JzDicId: null, //警种
        TypeDicId: null, // 问卷分类
        Score: null,
        status: 1,
        isOpen: 1,
        isPublic: true,
      },
      timer: '',
      jzlist: false,
      putaway: true,
    };
  },
  created() {
    this.questionMap();
    this.getDishi();
  },
  mounted() {
    this.getPmiDictionary(1, this.policeClassification);
    this.getPmiDictionary(56, this.questionnaireClass);
  },
  methods: {
    //查询新热
    policeNew(index, item) {
      this.newIndex = index;
    },
    getPmiDictionary(index, arr) {
      this.listQuery.namespaceId = index;
      vote
        .getPmiDic(this.listQuery)
        .then((response) => {
          response.result.forEach((e) => {
            arr.push({ name: e.name, id: e.id });
          });
          // console.log(response.data.name)
          this.$nextTick(()=>{
            if(this.$refs.jzlistobjerthree.clientHeight > 42){
              this.jzlist = true
            }
          })
        })
        .catch(() => {
          // debugger
        });
    },
    handleSizeChange(val) {
      this.listQuerya.Limit = val;
      this.questionMap();
    },

    handleCurrentChange(val) {
      this.listQuerya.Page = val;
      this.questionMap();
    },
    //查询地市
    selectCity(index, item) {
      this.cityIndex = index;
    },
    //获取地市
    getDishi() {
      getCity().then((res) => {
        res.result.forEach((e) => {
          this.cityList.push({ name: e.name, id: e.id });
        });
      });
    },
    //高亮展示
    policeClassArea(index, item) {
      this.policeClassindex = index;
      // debugger
      if (item.id == 0) {
        this.listQuerya.JzDicId = null;
      } else {
        this.listQuerya.JzDicId = item.id;
      }
      this.questionMap();
      this.timer = new Date().getTime();
    },
    quesionArea(index, item) {
      this.questionindex = index;
      if (item.id == 0) {
        this.listQuerya.TypeDicId = null;
      } else {
        this.listQuerya.TypeDicId = item.id;
      }
      this.questionMap();
      this.timer = new Date().getTime();
    },
    chooseClassArea(index, item) {
      this.chooseClassindex = index;
    },
    //获取问卷集合ajax
    questionMap() {
      let para = this.listQuerya;
      console.log(this.listQuerya);
      vote.getPollTopicList(this.listQuerya).then((res) => {
        this.changeColor(res.data);
        this.dataCount = res.count;
      });
    },
    changeColor(resultsList) {
      // resultsList全部数据，改变title里的高亮颜色，用正则先去匹配全局匹配到，然后用字符串的替换将原来的title替换需要高亮的部分
      resultsList.map((item, index) => {
        // console.log('item', item)
        if (this.listQuerya.Name && this.listQuerya.Name.length > 0) {
          // 匹配关键字正则
          let replaceReg = new RegExp(this.listQuerya.Name, 'gi');
          // 高亮替换v-html值
          let replaceString =
            '<span class="search-text" style="color:red;">' +
            this.listQuerya.Name +
            '</span>';
          resultsList[index].name = item.name.replace(
            replaceReg,
            replaceString
          );
        }
      });

      this.tableData = [];
      this.tableData = resultsList;
      console.log(this.tableData);
    },
    //点击获取单个问卷并跳转
    questionget(item) {
      // debugger
      this.$router.push({
        path: '/diaoy/questionget',
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          id: item.id,
        },
      });
    },
  },
};
</script>
<style scoped>
.nav {
  width: 1200px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  opacity: 1;
  margin: 0 auto;
  margin-top: 10px;
}
.nav > div {
  font-size: 19px;
  margin-left: 32px;
  padding-top: 5px;
}
.navpolice {
  font-size: 19px;
  margin-left: 32px;
  padding-top: 10px;
  display: flex;
}
.navpolice > div:nth-child(1) {
  flex: 1;
}
.navpolice > div:nth-child(2) {
  flex: 11;
}
.navpolice > div {
  margin-bottom: 7px;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.navpolice > div > div {
  line-height: 30px;
  font-size: 16px;
  color: #333333;
  margin-left: 20px;
  margin-top: 10px;
  background: #ececec;
  opacity: 1;
  border-radius: 6px;
  /* padding: 6px,12px; */
  padding-left: 10px;
  /* padding-top: 3px; */
  padding-right: 10px;
  /* padding-bottom: 3px; */
}
/* 高亮 */
.heightlight {
  background-color: #649FED !important;
  color: #f8fafc !important;
}
.box {
  margin: 0 auto;
  width: 1200px;
  margin-top: 14px;
  display: flex;
}
/* 左盒子是视频 */
.leftbox {
  width: 100%;
  max-height: 960px;
  background: linear-gradient(to bottom, #97CAF4 0%,#fff 300px,#fff 100%);
  border-radius: 4px;
}
/* 头部是全部最新最热三个标签 */
.leftbox > .leftboxheader {
  width: 880px;
  height: 46px;
  background: #ebf1f5;
  opacity: 1;
  border-radius: 6px 6px 0px 0px;
  line-height: 46px;
}
.leftbox > .leftboxheader > span {
  width: 58px;
  height: 28px;
  background: #f8fafc;
  opacity: 1;
  border-radius: 6px;
  padding-left: 12px;
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
  margin-left: 22px;
}
.leftboxmetter {
  width: 1200px;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 21px 19px 0px 19px;
}
.question {
  width: 280px;
  height: 139px;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
  margin-bottom: 22px;
}
.question + .question{
  margin-left: 14px;
}
.question:nth-child(4n + 1){
  margin-left: 0px;
}

.question > div:nth-child(1) {
  padding: 0px 26px;
}
.question > div:nth-child(1) > div {
  padding-top: 39px;
  font-size: 16px;
  color: #4291FE;
}
.question:hover {
  box-shadow: 1px 1px 5px rgba(156, 154, 154, 0.996);
}

.el-rate {
  padding-top: 2px;
  height: 24px;
}
.question > div:nth-child(2) {
  padding: 0px 26px;
  padding-top: 20px;
  font-size: 12px;
  line-height: 18px;
  color: #272636;
}
.page {
  margin-bottom: 44px;
  text-align: center;
  margin-top: 17px;
}
.trainicon {
  display: flex;
  align-items: center;
}
.traintext {
  /* min-width: 46px; */
  /* height: 23px; */
  padding: 3px 5px;
  background-color: #4876c4;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  margin-right: 8px;
}
.traingimgnametxtlil {
  font-size: 14px;
  display: flex;
  margin-top: 2px;
}
.trainicon > img {
  width: 16px;
  height: 16px;
  margin-right: 2px;
}

.cate {
  box-sizing: border-box;
  width: 1200px;
  background: #ffffff;
  margin: 0 auto;
  margin-top: 14px;
  border-radius: 4px;
  padding: 44px 28px 27px 35px;
}

.cate_police {
  display: flex;
  font-size: 16px;
}

.cate_police + .cate_police{
  margin-top: 12px;
}

.cate-all {
  width: 76px;
  font-size: 14px;
  line-height: 21px;
  margin-right: 10px;
}
.subject {
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding-right: 80px;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  height: 22px;
  padding: 0px 10px;
  color: #000;
  border: 1px solid white;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 20px;
}
.subject > span:hover {
  border: 1px solid #649FED;
  color: #649FED;
  border-radius: 4px;
}

/deep/.input-with-select input{
  border-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
/deep/.input-with-select .el-input-group__append{
  border-color: #51565C;
}

.subject >.showlist{
  position:absolute;
  z-index: 3;
  right: 5px;
  top: 0px;
  padding-left: 10px;
  cursor: pointer;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  color: #4D515A;
}
.hiddenlist{
  height: 42px;
}
</style>